export default __webpack_public_path__ + "static/genopets-2-b-d9a77f0dff01bfd1c521dd1015ca9d07.webp";